import type {
  BankIngestCommitRequest,
  BankIngestPreviewRequest,
} from '../generated/dtos.gen';

export type BankIngestCommitFields = Pick<BankIngestCommitRequest, 'fileBytesBase64'> &
  Partial<BankIngestCommitRequest>;

export function bankIngestCommitRequest(fields: BankIngestCommitFields): BankIngestCommitRequest {
  return {
    fileName: null,
    bankSourceProfileId: null,
    bankAccountId: null,
    useNoAccountBucket: false,
    mapping: null,
    newProfileBankIdentifier: null,
    dateFormat: null,
    signConvention: null,
    profileFormat: null,
    includeLockedRowIndices: null,
    previewFileSha256: null,
    ...fields,
  };
}

export type BankIngestPreviewFields = Pick<
  BankIngestPreviewRequest,
  'fileBytesBase64' | 'signConvention' | 'profileFormat'
> &
  Partial<BankIngestPreviewRequest>;

export function bankIngestPreviewRequest(fields: BankIngestPreviewFields): BankIngestPreviewRequest {
  return { fileName: null, bankSourceProfileId: null, mapping: null, dateFormat: null, ...fields };
}
